import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    asunto: "",
    mensaje: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<"idle" | "success" | "error">("idle");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("idle");

    try {
      const response = await fetch("https://readdy.ai/api/form/d5nahovpl7huldvcirp0", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({
          nombre: "",
          email: "",
          asunto: "",
          mensaje: ""
        });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm font-medium mb-4">
            Contáctenos
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Estamos Aquí Para Ayudarle
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            ¿Tiene preguntas sobre nuestros servicios? Envíenos un mensaje y le responderemos lo antes posible.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-phone-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Llámenos</h3>
            <a href="tel:+18556429085" className="text-teal-600 hover:text-teal-700 text-sm cursor-pointer">
              (855) 642-9085
            </a>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-mail-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Envíenos un Email</h3>
            <a href="mailto:info@verotaxgroupllc.com" className="text-teal-600 hover:text-teal-700 text-sm cursor-pointer break-all">
              info@verotaxgroupllc.com
            </a>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Visítenos</h3>
            <p className="text-gray-600 text-sm">Maryland, Estados Unidos</p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-gray-200">
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">
                  Nombre Completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="Juan Pérez"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Correo Electrónico *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="ejemplo@correo.com"
                />
              </div>
            </div>

            <div>
              <label htmlFor="asunto" className="block text-sm font-medium text-gray-700 mb-2">
                Asunto *
              </label>
              <input
                type="text"
                id="asunto"
                name="asunto"
                value={formData.asunto}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                placeholder="¿En qué podemos ayudarle?"
              />
            </div>

            <div>
              <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-2">
                Mensaje *
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                required
                rows={6}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                placeholder="Escriba su mensaje aquí..."
              ></textarea>
              <div className="text-xs text-gray-500 mt-1 text-right">
                {formData.mensaje.length}/500 caracteres
              </div>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-8 py-4 bg-teal-600 text-white font-semibold rounded-md hover:bg-teal-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
            >
              {isSubmitting ? "Enviando..." : "Enviar Mensaje"}
            </button>

            {submitStatus === "success" && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-md text-green-700 text-sm">
                ¡Gracias por contactarnos! Responderemos su mensaje lo antes posible.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
                Hubo un error al enviar su mensaje. Por favor, inténtelo de nuevo o llámenos directamente.
              </div>
            )}
          </form>
        </div>

        {/* Map */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Nuestra Ubicación</h3>
          <div className="w-full h-[400px] rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198059.85171286906!2d-77.20889984999999!3d39.04537705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7c6de5af6e45b%3A0xc2524522d4885d2a!2sMaryland%2C%20USA!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="VeroTax Services Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
